<template>
  <a
    :href="url"
    :target="target"
    @click="(e) => this.$emit('click', e)"
    @mouseover="(e) => this.$emit('mouseover', e)"
    @mouseenter="(e) => this.$emit('mouseenter', e)"
    @mouseleave="(e) => this.$emit('mouseleave', e)"
  >
    <slot></slot>
  </a>
</template>

<script>
import { query2Search, search2Query } from '@/common/utils';

export default {
  props: {
    to: String,
    href: String, // 兼容a标签写法
    target: String,
  },

  data() {
    return {
      base: '/learning',
    };
  },

  computed: {
    isOutsideUrl({ to, href, base }) {
      const url = to || href || '';
      return url.indexOf(base) === -1 && url.indexOf('http') === 0;
    },

    needBase({ to, href, base }) {
      const url = to || href || '';
      return url.indexOf('//') === -1 && url.indexOf(base) !== 0;
    },

    url({ to, href, needBase, base, $route, isOutsideUrl }) {
      const { query = {} } = $route;
      let url = to || href || '';
      url = needBase ? `${base}${url}` : url;

      // 假如query中带有renderMode，且链接非外部链接，保持参数
      if (query.renderMode && !process.server && !isOutsideUrl) {
        const arr = url.split('#');
        const queryArr = arr[0].split('?');
        const urlQuery = search2Query(queryArr[1]);
        arr[0] = `${queryArr[0]}${query2Search({
          ...urlQuery,
          renderMode: query.renderMode,
        })}`;

        url = arr.join('#');
      }

      return url;
    },
  },
};
</script>
